import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				padding: "0px !important",
				background: "#FDFEFD",
				height: "100%"
			},
			background: {
				background: "#d3d3d360",
				minHeight: "-webkit-fill-available"
			}
		}),
	{
		name: "ProductItem",
		index: 1
	}
);

export default useStyles;
